import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import PostWarning from './PostWarning';
export default class PostWarningList extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "post", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.post = this.attrs.post;
  }
  view() {
    return m("div", {
      className: "Post-warning-list"
    }, (this.attrs.post.warnings() || []).filter(Boolean).map(warning => {
      return PostWarning.component({
        warning
      });
    }));
  }
}
flarum.reg.add('fof-moderator-warnings', 'forum/components/PostWarningList', PostWarningList);